import React from "react";
import { Icon } from "Icons";
import cx from "classnames";

const IconsSwitch = ({ firstIcon, secondIcon, onChange, selectedIndex = 0 }) => {
  return (
    <div className="flex items-center">
      <div
        className={cx(
          "cursor-pointer border-[1px] rounded-l box-border h-8 flex items-center justify-center px-2 border-solid",
          {
            "bg-[--accent-l35] border-[--accent]": selectedIndex === 0,
            "border-[--text-a40] border-r-0": selectedIndex === 1,
          }
        )}
        onClick={() => onChange(0)}
      >
        <Icon
          svg={firstIcon}
          width="1rem"
          className={cx({
            "icon-stroke-accent": selectedIndex === 0,
          })}
        />
      </div>
      <div
        className={cx(
          "cursor-pointer border-[1px] rounded-r box-border h-8 flex items-center justify-center px-2 border-solid",
          selectedIndex === 1 ? "bg-[--accent-l35] border-[--accent]" : "border-[--text-a40]",
          selectedIndex === 0 ? "border-l-0" : ""
        )}
        onClick={() => onChange(1)}
      >
        <Icon
          svg={secondIcon}
          width="1rem"
          className={cx({
            "icon-stroke-accent": selectedIndex === 1,
          })}
        />
      </div>
    </div>
  );
};

export default IconsSwitch;
